module.exports = __webpack_public_path__ + "img/140.9.3548c5e5.png";